import React, { useEffect, useState } from "react";
import query from "jquery";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { clearAuthData, getUserData, hasRole, isAuthenticated } from "../auth";
import { useDispatch, useSelector } from "react-redux";
import { setSearchString } from "../common/slices/searchStringSlice";
import HomeIcon from '@mui/icons-material/Home';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import StorefrontIcon from '@mui/icons-material/Storefront';
import StoreIcon from '@mui/icons-material/Store';
import ShopIcon from '@mui/icons-material/Shop';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import DashboardIcon from '@mui/icons-material/Dashboard';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { LoginOutlined, LogoutOutlined } from "@mui/icons-material";
import { useGetPendingCartCountBySellerQuery } from "../apis/OrderAPi";
import { Badge, Menu, List, ListItem, ListItemText, Divider, Box, Typography } from "@mui/material";
import NotificationDropdown from "./notification/NotificationDropdown";

const HeaderOneCustomer = () => {
  const [scroll, setScroll] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false); 
  const [anchorEl, setAnchorEl] = useState(null);
  const [notifications, setNotifications] = useState([
    { id: 1, text: 'New order received', time: '2 mins ago', read: false },
    { id: 2, text: 'Payment confirmed', time: '1 hour ago', read: false },
    { id: 3, text: 'New message from customer', time: '3 hours ago', read: true },
  ]);
  
  const dispatch = useDispatch();
  const userData = getUserData();
  const roles = userData?.role || [];
  const sellerId = userData?.uid || "";
  const isCustomer = hasRole('ROLE_CUSTOMER');
  const isVendor = hasRole('ROLE_VENDER');
  const unreadCount = notifications.filter(n => !n.read).length;
  const open = Boolean(anchorEl);

  const { data: count } = useGetPendingCartCountBySellerQuery(sellerId, {
    pollingInterval: 5000,
    skip: !isVendor,
  });
  
  const cartItems = useSelector((state) => state.product.cart);
  const wishList = useSelector((state) => state.product.wishList);
  const compare = useSelector((state) => state.product.compare);
  const isLoggedInCustomer = loggedIn && isCustomer;

  // Notification handlers
  const handleNotificationClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const markAsRead = (id) => {
    setNotifications(notifications.map(n => 
      n.id === id ? {...n, read: true} : n
    ));
  };

  const markAllAsRead = () => {
    setNotifications(notifications.map(n => ({...n, read: true})));
  };
 
  // Other existing hooks and handlers...
  useEffect(() => {
    const checkAuthStatus = () => {
      const authStatus = isAuthenticated();
      setLoggedIn(authStatus);
    };

    checkAuthStatus();
    const intervalId = setInterval(checkAuthStatus, 1000);
    return () => clearInterval(intervalId);
  }, [loggedIn]);

  useEffect(() => {
    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };
    const selectElement = query(".js-example-basic-single");
    selectElement.select2();

    return () => {
      if (selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []); 

  const navigate = useNavigate();
  const handleLogout = () => {
    clearAuthData();
    navigate("/account");
  };
  
  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const handleMenuToggle = () => setMenuActive(!menuActive);
  const handleMenuClick = (index) => setActiveIndex(activeIndex === index ? null : index);
  
  // Search control support
  const [activeSearch, setActiveSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const handleSearchToggle = () => setActiveSearch(!activeSearch);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    dispatch(setSearchString(searchQuery));
    setTimeout(() => setLoading(false), 6000);
  };

  const handleSubmitMobile = (e) => {
    e.preventDefault();
    setActiveSearch(!activeSearch);
    dispatch(setSearchString(searchQuery));
  };

  // category control support
  const [activeCategory, setActiveCategory] = useState(false);

  return (
    <>
      <div className='overlay' />
      <div className={`side-overlay ${(menuActive || activeCategory) && "show"}`} />
      
      {/* Search Box */}
      {isCustomer && (
        <form onSubmit={handleSubmitMobile} className={`search-box ${activeSearch && "active"}`}>
          <button
            onClick={handleSearchToggle}
            type='button'
            className='search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-transparent text-2xl transition-1'
          >
            <i className='ph ph-x' />
          </button>
          <div className='container'>
            <div className='position-relative'>
              <input
                type='text'
                className='form-control py-16 px-24 text-xl rounded-pill pe-64'
                placeholder='Search for vendor store'
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button
                type='submit'
                className='w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8'
              >
                <i className='ph ph-magnifying-glass' />
              </button>
            </div>
          </div>
        </form>
      )}

      {/* Mobile Menu */}
      <div className={`mobile-menu scroll-sm d-lg-none d-block ${menuActive && "active"}`}>
        <button
          onClick={() => {
            handleMenuToggle();
            setActiveIndex(null);
          }}
          type='button'
          className='close-button'
        >
          <i className='ph ph-x' />{" "}
        </button>
        <div className='mobile-menu__inner'>
          <Link to='/' className='mobile-menu__logo'>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/logo/blinkBuyBlackLog.png`} 
              alt='Logo'
              style={{ width: '150px', height: 'auto' }}
            />      
          </Link>
          
          <div className='mobile-menu__menu'>
            <ul className='nav-menu flex-align nav-menu--mobile'>
              <li className='nav-menu__item'>
                <NavLink
                  to='/'
                  className={(navData) =>
                    navData.isActive ? "nav-menu__link activePage" : "nav-menu__link text-white"
                  }
                  onClick={() => setActiveIndex(null)}
                >
                  <HomeIcon sx={{ marginRight: 1 }} /> Home
                </NavLink>
              </li>

              {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER", "ROLE_CUSTOMER"].includes(role)) && (
                <li className='nav-menu__item'>
                  <NavLink
                    to='/wallet'
                    className={(navData) =>
                      navData.isActive ? "nav-menu__link activePage" : "nav-menu__link text-white"
                    }
                    onClick={() => setActiveIndex(null)}
                  >
                    <AccountBalanceWalletIcon sx={{ marginRight: 1 }} /> Wallet
                  </NavLink>
                </li>
              )}

              {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER"].includes(role)) && (
                <li className="nav-menu__item">
                  <NavLink
                    to="/vendor-orders"
                    className={(navData) =>
                      navData.isActive ? "nav-menu__link activePage" : "nav-menu__link text-white"
                    }
                    onClick={() => setActiveIndex(null)}
                  >
                    <span style={{ display: "flex", alignItems: "center" }}>
                      <ShoppingCartIcon sx={{ marginRight: 1 }} />
                      <Typography variant="body1" sx={{ marginRight: 1 }}>
                        Customer Orders
                      </Typography>
                      <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs">
                        {count ?? 0}
                      </span>
                    </span>
                  </NavLink>
                </li>
              )}
              
              {roles.some(role => ["ROLE_ADMIN", "ROLE_CUSTOMER"].includes(role)) && (
                <li className='nav-menu__item'>
                  <NavLink
                    to='/customer-orders'
                    className={(navData) =>
                      navData.isActive ? "nav-menu__link activePage" : "nav-menu__link text-white"
                    }
                    onClick={() => setActiveIndex(null)}
                  >
                    <ShoppingCartIcon sx={{ marginRight: 1 }} />Order
                  </NavLink>
                </li>
              )}

              {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER"].includes(role)) && (
                <li className='nav-menu__item'>
                  <NavLink
                    to='/wholesale-center'
                    className={(navData) =>
                      navData.isActive ? "nav-menu__link activePage" : "nav-menu__link text-white"
                    }
                    onClick={() => setActiveIndex(null)}
                  >
                    <StorefrontIcon sx={{ marginRight: 1 }} /> Wholesale Center
                  </NavLink>
                </li>
              )}

              {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER"].includes(role)) && (
                <li
                  onClick={() => handleMenuClick(3)}
                  className={`on-hover-item nav-menu__item has-submenu ${
                    activeIndex === 3 ? "d-block" : ""
                  }`}
                >
                  <Link to='#' className='nav-menu__link text-white'>
                    <StoreIcon sx={{ marginRight: 1 }} /> My Store
                  </Link>
                  <ul
                    className={`on-hover-dropdown common-dropdown nav-submenu scroll-sm ${
                      activeIndex === 3 ? "open" : ""
                    }`}
                  >
                    <li className='common-dropdown__item nav-submenu__item'>
                      <NavLink
                        to='/shop'
                        className={(navData) =>
                          navData.isActive ? "nav-menu__link activePage" : "nav-menu__link text-white"
                        }
                        onClick={() => setActiveIndex(null)}
                      >
                        <ShopIcon sx={{ marginRight: 1 }} /> My Store
                      </NavLink>
                    </li>
                    <li className='common-dropdown__item nav-submenu__item'>
                      <NavLink
                        to='/returned-product'
                        className={(navData) =>
                          navData.isActive ? "nav-menu__link activePage" : "nav-menu__link text-white"
                        }
                        onClick={() => setActiveIndex(null)}
                      >
                        <AssignmentReturnIcon sx={{ marginRight: 1 }} /> Return Products
                      </NavLink>
                    </li>
                  </ul>
                </li>
              )}
              
              {roles.some(role => ["ROLE_VENDER"].includes(role)) && (
                <li className='nav-menu__item'>
                  <NavLink
                    to='/dashboard-vendor'
                    className={(navData) =>
                      navData.isActive ? "nav-menu__link activePage" : "nav-menu__link text-white"
                    }
                    onClick={() => setActiveIndex(null)}
                  >
                    <DashboardIcon sx={{ marginRight: 1 }} /> Dashboard
                  </NavLink>
                </li>
              )}
              
              {roles.some(role => ["ROLE_CUSTOMER"].includes(role)) && (
                <li className='nav-menu__item'>
                  <NavLink
                    to='/dashboard-customer'
                    className={(navData) =>
                      navData.isActive ? "nav-menu__link activePage" : "nav-menu__link text-white"
                    }
                    onClick={() => setActiveIndex(null)}
                  >
                    <DashboardIcon sx={{ marginRight: 1 }} /> Dashboard
                  </NavLink>
                </li>
              )}
              
              {loggedIn ? (
                <li className='nav-menu__item'>
                  <NavLink
                    to='/account'
                    className={(navData) =>
                      navData.isActive ? "nav-menu__link activePage" : "nav-menu__link text-white"
                    }
                    onClick={() => handleLogout()}
                  >
                    <LoginOutlined sx={{ marginRight: 1 }} /> Logout
                  </NavLink>
                </li>
              ) : (
                <li className='nav-menu__item'>
                  <NavLink to='/account' className='text-white flex-align gap-4 item-hover'>
                    <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                      <i className="ph ph-user-circle" />
                    </span>
                    Login
                  </NavLink>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>

      {/* Middle Top */}
      <div className='header-top flex-between' style={{ backgroundColor: '#ff6000' }}>
        <div className='container container-lg'>
          <div className='flex-between flex-wrap gap-8'>
            <ul className='flex-align flex-wrap d-none d-md-flex'>
              <li className='border-right-item'>
                <Link
                  to='/become-seller'
                  className='text-white text-sm hover-text-decoration-underline'
                >
                  Become A Seller
                </Link>
              </li> 
            </ul>
            <ul className='header-top__right flex-align flex-wrap'>
              {loggedIn ? (
                <li className='on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white'>
                  <NavLink to='#' className='text-white text-sm  px-20 py-8'>
                    My profile
                  </NavLink>
                  <ul className='on-hover-dropdown common-dropdown common-dropdown--sm max-h-300 scroll-sm py-8'>
                    <li className='nav-submenu__item'>
                      {isCustomer && (
                        <NavLink
                          to="/profile"
                          className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                        >
                          <span className="text-sm d-flex">
                            <i className="ph ph-user-circle text-lg" />
                          </span>
                          Profile
                        </NavLink>
                      )}
                      {isVendor && (
                        <NavLink
                          to="/vendor-profile"
                          className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                        >
                          <span className="text-sm d-flex">
                            <i className="ph ph-user-circle text-lg" />
                          </span>
                          Profile
                        </NavLink>
                      )}
                    </li>
                    <li className='nav-submenu__item'>
                      <NavLink
                        to='/wallet'
                        className='nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0'
                      >
                        <span className='text-sm d-flex'>
                          <i className='ph ph-wallet text-lg' />
                        </span>
                        Wallet
                      </NavLink>
                    </li>
                    <li className='nav-submenu__item'>
                      {!isVendor && (
                        <NavLink
                          to='/become-seller'
                          className='nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0'
                        >
                          <span className='text-sm d-flex'>
                            <i className='ph ph-storefront text-lg' />
                          </span>
                          Become a seller
                        </NavLink>
                      )}
                    </li>
                  </ul>
                </li>
              ) : null}
            </ul>
          </div>
        </div>
      </div>

      {/* Middle Header */}
      <header className='' style={{ backgroundColor: '#c94a10' }}> 
        <div className='container container-lg'>
          <nav className='header-inner flex-between'>
            <div className='logo mt-4 mb-5'>
              <Link to='/' className='link'>
                <img
                  src={`/assets/images/logo/blinkBuyWhiteLog.png`} 
                  alt='Logo'
                  style={{ width: '180px', height: 'auto' }}
                /> 
              </Link>
            </div>
            
            {isCustomer && (
              <form onSubmit={handleSubmit}>
                <div className="search-category style-two d-flex h-32 search-form d-sm-flex d-none">
                  <div className='search-form__wrapper position-relative'>
                    <input
                      type="text"
                      className="search-form__input common-input py-8 ps-12 pe-40 rounded-end-pill pe-32"
                      placeholder="Search for vendor store"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <button
                      type="submit"
                      className="w-28 h-28 bg-main-600 rounded-circle flex-center text-lg text-white position-absolute top-50 translate-middle-y"
                      style={{ right: "5px", transform: "translateY(-50%)" }}
                    >
                      <i className="ph ph-magnifying-glass" />
                    </button>
                  </div>
                </div>
              </form>
            )}

            <div className='header-right flex-align d-lg-block d-none'>
              <div className='flex-align flex-wrap gap-12'>
                <button
                  type='button'
                  className='search-icon flex-align d-lg-none d-flex gap-4 item-hover'
                >
                  <span className='text-2xl text-white d-flex position-relative item-hover__text'>
                    <i className='ph ph-magnifying-glass' />
                  </span>
                </button>
                
                {isLoggedInCustomer ? (
                  <>
                    <NavLink to='/compare-list' className='flex-align gap-4 item-hover'>
                      <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                        <i className='ph-fill ph-shuffle' />
                        <span className='w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                          {compare.length}
                        </span>
                      </span>
                      <span className='text-md text-white item-hover__text d-none d-lg-flex'>
                        Compare
                      </span>
                    </NavLink>
                    <NavLink to='/wishlist' className='flex-align gap-4 item-hover'>
                      <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                        <i className='ph ph-heart' />
                        <span className='w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                          {wishList.length}
                        </span>
                      </span>
                      <span className='text-md text-white item-hover__text d-none d-lg-flex'>
                        Wishlist
                      </span>
                    </NavLink>
                    <NavLink to='/cart' className='flex-align gap-4 item-hover'>
                      <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                        <i className='ph ph-shopping-cart-simple' />
                        <span className='w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                          {cartItems.length}
                        </span>
                      </span>
                      <span className='text-md text-white item-hover__text d-none d-lg-flex'>
                        Cart
                      </span>
                    </NavLink>
                    
                    {/* Binance-style notification dropdown */}
                       <NotificationDropdown mobile={false} />
                  </>
                ) : isVendor ? (
                       <NotificationDropdown mobile />

                ) : null}
              </div>
            </div>
          </nav>
        </div>
      </header>

      {/* Main Header */}
      <header className={`header ${scroll && "fixed-header"}`} style={{ backgroundColor: '#c94a10' }}>
        <div className='container container-lg'>
          <nav className='header-inner d-flex justify-content-between gap-8'>
            <div className='flex-align menu-category-wrapper'>
              <div className='category on-hover-item'>
                <button 
                  type='button'
                  className='category__button flex-align gap-8 fw-medium p-16 border-end border-start border-gray-100 text-white'
                >
                  <span className='icon text-2xl d-xs-flex d-none'>
                    <i className='ph ph-dots-nine' />
                  </span>
                  <span className='d-sm-flex d-none'>Blink Buy</span> Dropshipping
                </button> 
              </div>
              
              <div className='header-menu d-lg-block d-none'>
                <ul className='nav-menu flex-align '>
                  <li className='nav-menu__item'>
                    <NavLink
                      to='/'
                      className={(navData) =>
                        navData.isActive ? "nav-menu__link activePage" : "nav-menu__link text-white"
                      }
                    >
                      Home
                    </NavLink>
                  </li>
                  
                  <li className='on-hover-item nav-menu__item'>
                    {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER","ROLE_CUSTOMER"].includes(role)) && (
                      <NavLink to='/wallet' className='nav-menu__link text-white'>
                        wallet
                      </NavLink>
                    )} 
                  </li>
                 
                  <li className='on-hover-item nav-menu__item'>
                    {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER"].includes(role)) && (
                      <NavLink to='/vendor-orders' className='nav-menu__link text-white'>
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <Typography variant="body1" sx={{ marginRight: 1 }}>
                            Customer Orders
                          </Typography>
                          <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs">
                            {count ?? 0}
                          </span>
                        </span>
                      </NavLink>
                    )}
                  </li>
                  
                  {roles.some(role => ["ROLE_ADMIN", "ROLE_VENDER"].includes(role)) && (
                    <>
                      <li className='on-hover-item nav-menu__item'>
                        <span className='badge-notification bg-tertiary-600 text-white text-sm py-2 px-8 rounded-4'>
                          Post to store 
                        </span>
                        <NavLink to='/wholesale-center' className='nav-menu__link text-white'>
                          Wholesale Center
                        </NavLink>
                      </li>
                      
                      <li className='on-hover-item nav-menu__item has-submenu arrow-white'>
                        <Link to='#' className='nav-menu__link text-white'>
                          My Store
                        </Link>
                        <ul className='on-hover-dropdown common-dropdown nav-submenu scroll-sm'>
                          <li className='common-dropdown__item nav-submenu__item'>
                            <NavLink
                              to='/shop'
                              className={(navData) =>
                                navData.isActive
                                  ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                                  : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                              }
                            >
                              My Store
                            </NavLink>
                          </li>
                          <li className='common-dropdown__item nav-submenu__item'>
                            <NavLink
                              to='/returned-product'
                              className={(navData) =>
                                navData.isActive
                                  ? "common-dropdown__link nav-submenu__link hover-bg-neutral-100 activePage"
                                  : "common-dropdown__link nav-submenu__link hover-bg-neutral-100"
                              }
                            >
                              Return Products
                            </NavLink>
                          </li>
                        </ul>
                      </li>
                      
                      <li className='nav-menu__item'>
                        <NavLink
                          to='/dashboard-vendor'
                          className={(navData) =>
                            navData.isActive ? "nav-menu__link activePage" : "nav-menu__link text-white"
                          }
                        >
                          Dashbord
                        </NavLink>
                      </li>
                    </>
                  )}
                  
                  <li className='on-hover-item nav-menu__item'>
                    {roles.some(role => ["ROLE_ADMIN","ROLE_CUSTOMER"].includes(role)) && (
                      <NavLink to='/customer-orders' className='nav-menu__link text-white'>
                        Orders
                      </NavLink>
                    )}
                  </li>
                  
                  <li className='on-hover-item nav-menu__item'>
                    {roles.some(role => ["ROLE_ADMIN","ROLE_CUSTOMER"].includes(role)) && (
                      <NavLink to='/dashboard-customer' className='nav-menu__link text-white'>
                        Dashbord
                      </NavLink>
                    )}
                  </li>
                </ul>
              </div>
            </div>
            
            <div className='header-right flex-align'>
              {loggedIn ? (
                <button
                  onClick={handleLogout}
                  className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none"
                >
                  <div className="d-flex text-32">
                    <i className="ph ph-sign-out" />
                  </div>
                  Logout
                </button>
              ) : (
                <Link
                  to="/account"
                  className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none"
                >
                  <div className="d-flex text-32">
                    <i className="ph ph-user-circle" />
                  </div>
                  Login
                </Link>
              )}
              
              <div className='me-16 d-lg-none d-block'>
                <div className='flex-align flex-wrap gap-12'>
                  {isLoggedInCustomer ? (
                    <>
                      <button
                        onClick={handleSearchToggle}
                        type='button'
                        className='search-icon flex-align d-lg-none d-flex gap-4 item-hover'
                      >
                        <span className='text-2xl text-white d-flex position-relative item-hover__text'>
                          <i className='ph ph-magnifying-glass' />
                        </span>
                      </button>
                      
                      <NavLink to='/compare-list' className='flex-align gap-4 item-hover'>
                        <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                          <i className='ph-fill ph-shuffle' />
                          <span className='w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                            {compare.length}
                          </span>
                        </span>
                        <span className='text-md text-white item-hover__text d-none d-lg-flex'>
                          Compare
                        </span>
                      </NavLink>
                      
                      <NavLink to='/wishlist' className='flex-align gap-4 item-hover'>
                        <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                          <i className='ph ph-heart' />
                          <span className='w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                            {wishList.length}
                          </span>
                        </span>
                        <span className='text-md text-white item-hover__text d-none d-lg-flex'>
                          Wishlist
                        </span>
                      </NavLink>
                      
                      <NavLink to='/cart' className='flex-align gap-4 item-hover'>
                        <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                          <i className='ph ph-shopping-cart-simple' />
                          <span className='w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4'>
                            {cartItems.length}
                          </span>
                        </span>
                        <span className='text-md text-white item-hover__text d-none d-lg-flex'>
                          Cart
                        </span>
                      </NavLink>
                       {<NotificationDropdown mobile />}

                     </>
                  ) : (
                    <>
                      {(isVendor || isCustomer) && <NotificationDropdown mobile />}
                      
                      {loggedIn ? (
                        <NavLink
                          to='/account'
                          className='text-white flex-align gap-4 item-hover'
                          onClick={handleLogout}
                        >
                          <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                            <i className="ph ph-user-circle" />
                          </span>
                          Logout
                        </NavLink>
                      ) : (
                        <NavLink to='/account' 
                          className='text-white flex-align gap-4 item-hover'
                        >
                          <span className='text-2xl text-white d-flex position-relative me-6 mt-6 item-hover__text'>
                            <i className="ph ph-user-circle" />
                          </span>
                          Login
                        </NavLink>
                      )}
                    </>
                  )}
                </div>
              </div>
              
              <button
                onClick={handleMenuToggle}
                type='button'
                className='toggle-mobileMenu d-lg-none ms-3n text-white text-4xl d-flex'
              >
                <i className='ph ph-list' />
              </button>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default HeaderOneCustomer;
